import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { RiShareFill } from "react-icons/ri";
import ShareModal from "./share-modal";

const Share = ({ title, description, label, handleSendAlgoliaEvent }) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({ canonical: "", url: "" });
  const shareDetails = { url: config.url, title, description };

  useEffect(() => {
    const canonical = document.querySelector("link[rel=canonocal]");
    const url = canonical ? canonical.href : document.location.href;
    setConfig({
      canonical,
      url,
    });
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        const share = await navigator.share(shareDetails);
        console.log("share", share);
        handleSendAlgoliaEvent(true);
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      setOpen(true);
      console.log(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
    }
  };
  return (
    <div className="relative flex items-center justify-center">
      <button
        className="sharer-button flex justify-center items-center gap-2"
        onClick={handleShare}
      >
        <RiShareFill />
        <span className="sharer-button-text">{label || t("Share")}</span>
      </button>
      <ShareModal {...{ url: config.url, title, t, open, setOpen }} />
    </div>
  );
};

export default Share;
